// Cross-repo cookie contract. web-builder-shopify-app reads this on the Pages screen to pick the
// GemX banner without asking the API whether a save/publish actually succeeded. Keep the key + values
// in sync with web-builder-shopify-app
// app/modules/shopifiy-pages/page-list/app/constants/index.ts (PAGES_LAST_ACTION_COOKIE_KEY).
const PAGES_LAST_ACTION_COOKIE_KEY = 'gp_pages_last_action';
const EXPIRE_DAYS = 365;

export type PagesLastAction = 'SAVED' | 'PUBLISHED';

// Registrable domain of the current host so the cookie is shared across *.gempages.net (app + editor)
// subdomains. Returns undefined on localhost / IPs, where we skip writing the cookie entirely (can't
// be shared locally — run both apps under a shared domain like *.lvh.me to test the shared flow).
const getSharedCookieDomain = (): string | undefined => {
  const host = window.location.hostname;
  if (!host || host === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return undefined;

  const parts = host.split('.');
  return parts.length >= 2 ? parts.slice(-2).join('.') : undefined;
};

export const recordPagesLastAction = (shopDomain: string | undefined | null, action: PagesLastAction): void => {
  if (!shopDomain || typeof document === 'undefined') return;

  // Without a shared domain the cookie would leak across every store in the browser — skip it.
  const domain = getSharedCookieDomain();
  if (!domain) return;

  const expires = new Date();
  expires.setDate(expires.getDate() + EXPIRE_DAYS);

  try {
    document.cookie = `${PAGES_LAST_ACTION_COOKIE_KEY}:${shopDomain}=${action}; expires=${expires.toUTCString()}; path=/; domain=${domain}; Secure; SameSite=None`;
  } catch {
    // Blocked/partitioned cookie contexts just leave the app to fall back to its API — ignore.
  }
};
